module.exports = __webpack_public_path__ + "static/media/ic-coffee.4200a32a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-coffee.svg
// module id = 613
// module chunks = 14